var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 233.01 150.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1 {        fill: #b7a662;      }      .cls-2 {        clip-path: url(#clippath);      }    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.64,
    width: 5.33,
    height: 65.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.56,119.22h-6.82c-1.31,0-2.37-1.06-2.37-2.37s1.06-2.36,2.37-2.36h6.82c12.85,0,23.31-10.42,23.31-23.24v-47.1c0-5.23-4.27-9.48-9.52-9.48h-107.93c-1.31,0-2.38-1.06-2.38-2.36s1.06-2.36,2.38-2.36h107.93c7.86,0,14.27,6.38,14.27,14.21v47.1c0,15.42-12.58,27.97-28.06,27.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.78,119.22h-8.72c-15.47,0-28.06-12.55-28.06-27.97v-47.1c0-7.84,6.4-14.21,14.27-14.21h5.43c1.31,0,2.37,1.06,2.37,2.36s-1.06,2.36-2.37,2.36h-5.43c-5.24,0-9.52,4.25-9.52,9.48v47.1c0,12.82,10.45,23.24,23.31,23.24h8.72c1.31,0,2.37,1.06,2.37,2.36,0,1.31-1.06,2.37-2.37,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.74,29.93h-9.49c-1.31,0-2.38,1.06-2.38,2.36s1.06,2.36,2.38,2.36c5.24,0,9.52,4.26,9.52,9.48v47.11c0,12.81-10.46,23.24-23.31,23.24h-6.82c-1.31,0-2.38,1.06-2.38,2.36s1.06,2.36,2.38,2.36h6.82c.69,0,1.38-.03,2.05-.08.2.05.41.08.61.08h6.82c15.47,0,28.06-12.55,28.06-27.97v-47.1c0-7.84-6.4-14.21-14.27-14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.23,97.93H25.39c-1.31,0-2.37-1.06-2.37-2.36s1.06-2.36,2.37-2.36h170.84c1.31,0,2.38,1.06,2.38,2.36s-1.06,2.36-2.38,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.23,50.61h-18.03c-1.31,0-2.37-1.06-2.37-2.36s1.06-2.36,2.37-2.36h18.03c1.31,0,2.38,1.06,2.38,2.36s-1.06,2.36-2.38,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.22,105.63H41.05c-4.96,0-8.99-4.03-8.99-8.97v-1.09c0-1.31,1.06-2.36,2.37-2.36s2.38,1.06,2.38,2.36v1.09c0,2.34,1.91,4.24,4.25,4.24h137.17c2.34,0,4.25-1.9,4.25-4.24v-1.09c0-1.31,1.06-2.36,2.38-2.36s2.37,1.06,2.37,2.36v1.09c0,4.94-4.04,8.97-8.99,8.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.24,150.99c-.63,0-1.25-.24-1.72-.73-.9-.94-.87-2.44.08-3.34,9.25-8.81,13.71-22.61,11.36-35.15-.24-1.29.61-2.52,1.9-2.76,1.3-.23,2.53.61,2.77,1.89,2.64,14.07-2.37,29.55-12.74,39.44-.46.44-1.05.66-1.64.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.93,150.99c-.63,0-1.25-.24-1.71-.73-.91-.94-.87-2.44.07-3.34,9.25-8.81,13.71-22.61,11.36-35.15-.24-1.29.61-2.52,1.9-2.76,1.29-.23,2.53.61,2.77,1.89,2.64,14.07-2.36,29.55-12.74,39.44-.46.44-1.05.66-1.64.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.63,150.99c-.63,0-1.25-.24-1.71-.73-.91-.94-.87-2.44.07-3.34,9.25-8.81,13.71-22.61,11.36-35.15-.24-1.29.61-2.52,1.9-2.76,1.29-.23,2.53.61,2.77,1.89,2.64,14.07-2.36,29.55-12.74,39.44-.46.44-1.05.66-1.64.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.32,150.99c-.63,0-1.25-.24-1.71-.73-.91-.94-.87-2.44.07-3.34,9.25-8.81,13.71-22.61,11.36-35.15-.24-1.29.61-2.52,1.9-2.76,1.29-.23,2.53.61,2.77,1.89,2.64,14.07-2.37,29.55-12.74,39.44-.46.44-1.05.66-1.64.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.01,150.99c-.63,0-1.25-.24-1.71-.73-.91-.94-.87-2.44.08-3.34,9.25-8.81,13.71-22.61,11.36-35.15-.24-1.29.61-2.52,1.9-2.76,1.29-.23,2.53.61,2.77,1.89,2.64,14.07-2.37,29.55-12.75,39.44-.46.44-1.05.66-1.64.66Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.64,
    width: 5.33,
    height: 65.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.08,65.03c-1.31,0-2.37-1.06-2.37-2.36V2.35C57.71,1.05,58.77-.01,60.08-.01s2.38,1.06,2.38,2.36v60.31c0,1.31-1.06,2.36-2.38,2.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.02,20.16l-10.97-12.77c-.85-.99-.74-2.48.26-3.33.99-.85,2.49-.74,3.34.26l7.49,8.71,8.06-8.77c.89-.96,2.39-1.03,3.35-.15.96.88,1.03,2.38.15,3.34l-11.68,12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.95,62.12c-.63,0-1.26-.24-1.73-.74l-7.82-8.28-7.82,8.28c-.9.95-2.4.99-3.35.1s-1-2.4-.1-3.34l11.28-11.94,11.28,11.94c.9.95.85,2.45-.1,3.34-.45.43-1.04.64-1.63.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.01,49.61c-.82,0-1.62-.43-2.06-1.19-.65-1.13-.26-2.58.88-3.23l52.46-30.02c1.14-.65,2.59-.26,3.24.88s.26,2.58-.88,3.23l-52.46,30.02c-.37.21-.78.32-1.18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.35,29.86c-.18,0-.35-.02-.52-.06l-16.88-3.77,5.65-15.84c.44-1.23,1.8-1.88,3.03-1.44,1.23.44,1.88,1.79,1.44,3.02l-3.85,10.81,11.65,2.6c1.28.28,2.08,1.55,1.8,2.82-.25,1.1-1.23,1.85-2.31,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.45,56.7c-.23,0-.46-.03-.69-.1-1.26-.38-1.96-1.7-1.58-2.95l3.31-10.89-11.09-2.64c-1.28-.3-2.06-1.58-1.76-2.85.31-1.27,1.58-2.06,2.86-1.76l16,3.81-4.77,15.69c-.31,1.02-1.25,1.68-2.27,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.1,49.32c-.39,0-.78-.09-1.14-.29l-53.09-28.89c-1.15-.63-1.58-2.06-.95-3.21.63-1.15,2.07-1.57,3.22-.94l53.1,28.88c1.15.63,1.57,2.06.95,3.21-.43.79-1.25,1.23-2.09,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.3,56.29c-.99,0-1.91-.61-2.24-1.6l-5.6-16.31,16.5-3.49c1.29-.27,2.55.54,2.82,1.82.27,1.28-.55,2.53-1.83,2.8l-11.26,2.39,3.87,11.26c.42,1.23-.24,2.58-1.48,3.01-.25.08-.51.13-.77.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.83,30.47c-1.05,0-2.01-.7-2.29-1.77-.33-1.27.43-2.56,1.69-2.89l11.04-2.88-3.55-10.81c-.41-1.24.28-2.58,1.52-2.98,1.25-.4,2.59.28,2.99,1.52l5.11,15.59-15.91,4.15c-.2.05-.41.08-.6.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAire);
export default __webpack_public_path__ + "static/media/aire.7ca0db02041d524321f97f4ce77243ea.svg";
export { ForwardRef as ReactComponent };